import "./styles.css";
import React, { useState, useEffect } from "react";
import { Box, Grid, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

import { FormattedMessage } from "react-intl";
import TickIcon from "../../assets/icons/TickIcon";
import ErrorIcon from "../../assets/icons/ErrorIcon";

export default function ValidationMessage({ closeButton = true, ...props }) {
  const [formColor, setFormColor] = useState(false);

  useEffect(() => {
    if (
      props.messages?.[0]?.messages?.filter((e) => e.type === "error").length >
      0
    ) {
      setFormColor("error");
    } else setFormColor("success");
  }, [props]);

  const getIcon = (type) => {
    if (type === "success") {
      return (
        <DoneIcon
          aria-label="Success icon"
          style={{
            color: "var(--text-success)",
            fontSize: "12px",
            marginTop: "6px",
          }}
        />
      );
    } else {
      return (
        <CloseIcon
          aria-label="Failure icon"
          style={{
            color: "var(--text-error)",
            fontSize: "12px",
            marginTop: "6px",
          }}
        />
      );
    }
  };

  return (
    <Collapse in={props.visible} style={{ transformOrigin: "0 0 0" }}>
      <Box className={`box-${formColor}`}>
        {closeButton && (
          <IconButton
            title={"Close"}
            aria-label="Close validation messages"
            color="primary"
            component="span"
            style={{
              width: "1.5rem",
              height: "1.5rem",
              position: "absolute",
              top: "0.5rem",
              right: "0.5rem",
            }}
            onClick={() => props.setVisible(false)}
          >
            <CloseIcon
              arai-label="Close icon"
              style={{
                fontSize: "18px",
              }}
              className={formColor === "error" ? "text-error" : "text-success"}
            />
          </IconButton>
        )}
        <div style={{ width: "100%" }}>
          {props.messages?.map((item, i) => {
            return (
              <div key={item.title + "-" + i}>
                <div>
                  <div
                    className={`validation-message-title ${
                      formColor === "error" ? "text-error" : "text-success"
                    }`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {formColor === "error" && (
                        <ErrorIcon size="24px" color="var(--new-error)" />
                      )}
                      {formColor === "success" && (
                        <TickIcon size="24px" color="var(--new-success)" />
                      )}
                    </div>
                    <FormattedMessage id={item.title} />
                  </div>
                </div>
                <div
                  style={{
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  <Grid container spacing={1}>
                    {item.messages.map((item, index, arr) => {
                      return (
                        <Grid
                          key={index}
                          item
                          xs={12}
                          sm={arr.length === 1 ? 12 : 6}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                            key={item.text + "-" + index}
                          >
                            {getIcon(item.type)}
                            <span
                              className={`validation-message-text ${
                                item.type === "error"
                                  ? "text-error"
                                  : "text-success"
                              }`}
                              style={{ marginLeft: "8px" }}
                            >
                              {React.isValidElement(item.text) ? (
                                item.text
                              ) : (
                                <FormattedMessage id={item.text} />
                              )}
                            </span>
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </div>
              </div>
            );
          })}
        </div>
      </Box>
    </Collapse>
  );
}
